import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'gotowi-na-siatkowke-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-9 w-full items-center justify-center bg-brand-navy px-3 text-white" data-id="element-156" data-mp="3ollqr5yxxulo">
      <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-157" data-mp="3tilyrmfcp7ff">
        <p className="whitespace-nowrap text-[9px] font-extrabold uppercase tracking-wide sm:text-[10px]" data-id="element-158" data-mp="3emd3evykze8a">
          ⚡ OFERTA STARTOWA KOŃCZY SIĘ ZA:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`Pozostało ${timeLeft.hours} godzin, ${timeLeft.minutes} minut, ${timeLeft.seconds} sekund`} data-id="element-159" data-mp="3jjczce1pv0lo">
          <TimerUnit value={timeLeft.hours} label="GODZ" data-id="element-160" data-mp="3amvx60bbyd22" />
          <span className="text-xs font-bold" data-id="element-161" data-mp="13vwgl696mwzb">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-162" data-mp="18to5drej62za" />
          <span className="text-xs font-bold" data-id="element-163" data-mp="18t64ghgxb0l1">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEK" data-id="element-164" data-mp="16fj09qkobmyo" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-165" data-mp="xebc41bvg2ib">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-166" data-mp="sfruue883ewa">{label}</span>
    </span>;
}